import { CLUB_MEMBERSHIP_REQUESTING } from 'redux/clubMemberships/constants';

import {
  GET_CLUB_MEMBER_SHIPMENT_SKIP_UNSKIP_SUCCESS,
  GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
  GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_ERROR,
  GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS,
  GET_CLUB_MEMBER_VIRTUAL_SHIPMENT_SUCCESS,
  LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS,
  RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  virtualCart: null,
  isListFetching: false,
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CLUB_MEMBERSHIP_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }

    case GET_CLUB_MEMBER_SHIPMENT_SUCCESS: {
      const data = { ...state.data };

      data[action.payload.id].items = action.payload.items;

      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }

    case GET_CLUB_MEMBER_SHIPMENT_SKIP_UNSKIP_SUCCESS: {
      const data = { ...state.data };

      data[action.payload.id] = {
        ...data[action.payload.id],
        processingStatus: action.payload.processingStatus
      };

      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }

    case RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_SUCCESS: {
      const virtualCart = { ...state.virtualCart };

      virtualCart[action.payload.id] =
        state.data[action.payload.id].virtualCart;

      virtualCart[action.payload.id].virtualTest = {
        isSuccess: true,
        missingCount: 0,
        missingTotal: 0
      };
      return {
        ...state,
        virtualCart,
        isObjectFetching: false
      };
    }
    case GET_CLUB_MEMBER_VIRTUAL_SHIPMENT_SUCCESS: {
      const virtualCart = { ...state.virtualCart };

      virtualCart[action.clubMemberShipmentId] = action.payload;

      return {
        ...state,
        virtualCart,
        isObjectFetching: false
      };
    }
    case LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS: {
      const data = { ...state.data };
      action.payload.clubMemberShipments.forEach((clubMemberShipment) => {
        data[clubMemberShipment.id] = clubMemberShipment;
      });
      return {
        ...state,
        data,
        isListFetching: false
      };
    }
    case GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS: {
      const virtualCart = { ...state.virtualCart };

      // we need to store the virtualCart in order to discard changes to default one
      const data = { ...state.data };
      data[action.clubMemberShipmentId].virtualCart = action.payload;

      virtualCart[action.clubMemberShipmentId] = action.payload;
      virtualCart[action.clubMemberShipmentId].virtualTest = {
        isSuccess: true,
        missingCount: 0
      };
      return {
        ...state,
        virtualCart,
        isObjectFetching: false
      };
    }
    case GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_ERROR: {
      const data = { ...state.data };

      data[action.clubMemberShipmentId].virtualCartError =
        action.payload.errorMessage;

      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
